// tslint:disable:trailing-comma

import BaseChannel from './base-channel';
import { LXStatSendParams, StatReportType } from '../constants';
import { debug, DebugLevel } from '../../util/debug';
import { NeoNamespace } from '../../common-enum';

/**
 * 灵犀统计模块
 */
export class LXAnalyticsChannel extends BaseChannel {
  defaultOptions = {
    withPageInfo: false, // withPageInfo 表示点击事件埋点是否携带上一次发送PV的 valLab 信息
  };
  constructor() {
    super();
    this.available = 'LXAnalytics' in window;
  }

  send(params: LXStatSendParams): void {
    switch (params.type) {
      case StatReportType.VIEW:
        this.view(params.bid, params.lab, params.options);
        break;
      case StatReportType.CLICK:
        this.click(params.bid, params.lab, params.options);
        break;
      case StatReportType.PV:
        this.pv(params.cid, params.lab, params.enviroment, params.options);
        break;
      case StatReportType.SC:
        this.sc(params.bid, params.lab, params.options);
        break;
      default:
        break;
    }
  }

  /**
   * 上报页面 PV
   * @param cid 页面 CID
   * @param lab 上报数据
   * @param enviroment 灵犀环境配置
   */
  private pv(
    cid: string = '',
    lab: object,
    enviroment: object,
    options: object
  ) {
    if (!this.available || !cid) {
      debug(
        NeoNamespace.StatLXAnalyticsChannel,
        DebugLevel.Error,
        'cid is empty'
      );
      return;
    }
    window.LXAnalytics(
      'pageView',
      {
        ...lab,
      },
      enviroment,
      cid
    );
  }

  private click(bid: string = '', lab: object, opts: object) {
    if (!this.available || !bid) {
      debug(
        NeoNamespace.StatLXAnalyticsChannel,
        DebugLevel.Error,
        `bid is empty, lab: ${lab}`
      );
      return;
    }
    window.LXAnalytics(
      'moduleClick',
      bid,
      { ...lab },
      { ...this.defaultOptions, ...opts }
    );
  }

  private view(bid: string = '', lab: object, opts: object) {
    if (!this.available || !bid) {
      debug(
        NeoNamespace.StatLXAnalyticsChannel,
        DebugLevel.Error,
        `bid is empty, lab: ${lab}`
      );
      return;
    }
    window.LXAnalytics(
      'moduleView',
      bid,
      { ...lab },
      { ...this.defaultOptions, ...opts }
    );
  }

  private sc(bid: string = '', lab: object, opts: object) {
    if (!this.available || !bid) {
      debug(
        NeoNamespace.StatLXAnalyticsChannel,
        DebugLevel.Error,
        `bid is empty, lab: ${lab}`
      );
      return;
    }
    window.LXAnalytics(
      'systemCheck',
      bid,
      { ...lab },
      { ...this.defaultOptions, ...opts }
    );
  }
}
